export const container = {
  margin: '0 auto',
  maxWidth: '100%',
  width: 'container.width',
};
